import { Grid } from '@material-ui/core';
import { Currency, getMoneySymbolByCurrency } from '@nemuru-eng/js-api-client';

import { CartItemDialogCommonFieldsProps } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/CartItemDialogCommonFieldsProps';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const CartItemDialogCommonFields = ({ disableUnits }: CartItemDialogCommonFieldsProps) => {
  const {
    state: { cart },
  } = useApplicationContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <NumberFormField
          type={'number'}
          name={'item.units'}
          disabled={disableUnits}
          label={'UNITS'}
          InputProps={{ inputProps: { min: 1 } }}
          fieldVariant={FieldVariant.form}
          allowDecimals={false}
        />
      </Grid>
      <Grid item xs={6}>
        <NumberFormField
          name={'item.price'}
          valueUnit={getMoneySymbolByCurrency(cart?.currency ?? Currency.EUR)}
          label={disableUnits ? 'TOTAL_PRICE' : 'UNIT_PRICE'}
          fieldVariant={FieldVariant.form}
          style={{ textAlign: 'right' }}
        />
      </Grid>
    </Grid>
  );
};
